import share from '@devices/settings/device_settings/share.js';
import wave_application_settings from '@devices/settings/device_settings/wave_application_settings.js';
import wave_device_settings from '@devices/settings/device_settings/wave_device_settings.js';
import timer_wave from '@devices/settings/device_settings/timer_wave.js';

export default {
	name: 'ShellyZwaveDimmer',
	friendly_name: 'Z-Wave Dimmer',
	family: 'light',
	isPM: false,
	gen: 'GZ',
	modes: {
		white: {
			channels: 1,
			notifications: ['offline', 'device_problem', 'forgotten_lights'],
			settings: [timer_wave, wave_application_settings, share, wave_device_settings],
		},
	},
};
